import { useEffect } from 'react'
import { Errcode } from 'src/constants/errcode'
import { setStorageInfo } from 'src/store/Reducer/socket/storageInfoSlice'
import { Cmdtypes } from 'src/constants/cmdtypes'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'

import { ResponseDataBody, ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import { useLocation } from 'react-router-dom'
import { setExplorerStorageLoading } from 'src/store/Reducer/page/explorerPageSlice'

const useExplorerMainEventBus = () => {
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()

  useEffect(() => {
    const StorageInfoResponseListener = eventBus.subscribe<ResponseDataBody.StorageInfo>(
      Cmdtypes.EXPLORER_STORAGE_SIZE,
      handleStorageInfoResponse,
    )
    return () => {
      StorageInfoResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleStorageInfoResponse = (message: ResponseDataType<ResponseDataBody.StorageInfo>) => {
    const { Header, Body } = message.responseData
    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setStorageInfo(Body))
    } else console.error(Header)
    dispatch(setExplorerStorageLoading(false))
  }
}
export default useExplorerMainEventBus
